module.exports = __webpack_public_path__ + "static/BT-desktop-8-2e62c4c1e420fce3063eeb0c7e8205b3.jpg";